import { useState } from "react";
import { faqs } from "@/mocks/content";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map((faq) => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold tracking-wide uppercase mb-4">
            FAQ
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">
            Frequently Asked Questions
          </h2>
          <p className="text-foreground-600 mt-3 max-w-xl mx-auto text-sm md:text-base">
            Everything you need to know about the Vigorbuy Spreadsheet — answered.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 pr-4">
                  {faq.question}
                </h3>
                <div className={`w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 transition-colors ${
                  openIndex === idx ? "bg-primary-100" : "bg-background-200"
                }`}>
                  <i className={`text-sm transition-transform duration-300 ${
                    openIndex === idx ? "ri-subtract-line text-primary-600 rotate-180" : "ri-add-line text-foreground-500"
                  } w-4 h-4 flex items-center justify-center`}></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? "max-h-96" : "max-h-0"
                }`}
              >
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 p-6 md:p-8 bg-primary-50 rounded-2xl border border-primary-100 text-center">
          <h4 className="text-lg font-heading font-semibold text-foreground-950 mb-2">
            Ready to explore the Vigorbuy Spreadsheet?
          </h4>
          <p className="text-sm text-foreground-600 mb-5 max-w-md mx-auto">
            Start discovering curated finds across all 14 categories. The latest Vigorbuy Spreadsheet 2026 is waiting for you.
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Explore Now
            <i className="ri-arrow-right-line text-sm w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}